<template>
    <div>
        <h1>{{ $t('site.common.enter') }} {{ $t('site.common.fellowship') }}</h1>

        <div class="row">
            <div class="col-md-8">
                <elv-fellowship-search-box :jumpToEnabled="true"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8">
                <v-alert outline color=info icon=info :value="true">
                    {{ $t('site.common.comingSoon') }} - enhanced ranking lists which will show details about each player such as boosts, technology chapter, etc.
                </v-alert>
            </div>
        </div>

        <!-- Remove Once footer is fixed -->
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>
        <BR/>

    </div>
</template>

<script>
    import ElvFellowshipSearchBox from "@/components/ElvFellowshipSearchBox";
    import axios from 'axios';

    export default {
        name: 'Fellowships',
        components: { ElvFellowshipSearchBox},
        data () {
            return {
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Fellowships.vue